<p-select
  [autofocus]="false"
  [options]="options"
  [(ngModel)]="selectedOption"
  optionLabel="label"
  placeholder="Klijenti:"
  class="w-full"
  [showClear]="true"
  (onChange)="onSelect.emit($event.value?.value ?? undefined)"
  [dt]="dropdownStyle"
>
  <ng-template #selectedItem let-selectedOption>
    <div class="flex align-items-center gap-1 white-space-nowrap">
      <span class="text-sm-medium text-gray-500">Klijenti:</span>
      <span class="text-sm-semibold text-gray-900">{{selectedOption.label}}</span>
    </div>
  </ng-template>
  <ng-template #dropdownicon>
    <app-chevron-right class="dropdown-chevron" direction="down" stroke="#ADB0B8" width="7px" height="12px"></app-chevron-right>
  </ng-template>
  <ng-template let-option #item>
    <div class="flex align-items-center gap-2">
      <app-dynamic-icon [iconComponent]="option.icon"></app-dynamic-icon>
      <div class="text-sm-semibold text-gray-800">{{option.label}}</div>
    </div>
  </ng-template>
</p-select>
